export const potionData = [ 
    { id: 1, name: 'Any Potion' },
    { id: 2, name: 'Strength' },
    { id: 3, name: 'Speed' },
    { id: 4, name: 'Concentration' }
];
